import { render } from "./TemplatePreviewPage.vue?vue&type=template&id=5668d427&scoped=true"
import script from "./TemplatePreviewPage.vue?vue&type=script&lang=js"
export * from "./TemplatePreviewPage.vue?vue&type=script&lang=js"

import "./TemplatePreviewPage.vue?vue&type=style&index=0&id=5668d427&lang=scss&scoped=true"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5668d427"]])

export default __exports__